import { updateItems } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          最新动态
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10">
          平台快讯与影片更新，不错过每一部好片
        </p>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-3 md:left-3.5 top-0 bottom-0 w-px bg-background-300/40"></div>

            {updateItems.map((item, idx) => (
              <div key={idx} className="relative pb-8 last:pb-0">
                <div className={`absolute left-[-1.35rem] md:left-[-1.65rem] top-1 w-3 h-3 rounded-full border-2 ${
                  item.type === 'hot'
                    ? 'bg-accent-500 border-accent-500'
                    : item.type === 'new'
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-secondary-500 border-secondary-500'
                }`}></div>

                <div className="bg-background-50 border border-background-200/30 rounded-lg p-4 hover:border-background-300/50 transition-colors cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className={`text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap ${
                      item.type === 'hot'
                        ? 'bg-accent-500/15 text-accent-400'
                        : item.type === 'new'
                        ? 'bg-primary-500/15 text-primary-400'
                        : 'bg-secondary-500/15 text-secondary-400'
                    }`}>
                      {item.type === 'hot' ? '热门' : item.type === 'new' ? '上新' : '资讯'}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-200 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}